import { useMemo, useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { queryClient } from '@/app/QueryClientProvider';
import { ConstructorApi } from '@/features/constructorDocuments/api';
import { usePopups } from '@/hooks';

export const useDocumentSection = (id) => {
  const { showErrorToast, showSuccessToast } = usePopups();
  const { isLoading, isError, data, error, refetch } = useQuery({
    queryKey: ['getDocumentSections'],
    queryFn: ConstructorApi.getDocumentSections,
    select: (res) => res.data
  });
  const [isChangingRole, setIsChangingRole] = useState(false);

  const [isUpdating, seIstUpdating] = useState(false);

  const [isDeleting, setIsDeleting] = useState(false);

  const questionnaire = useMemo(() => {
    if (!data || !data?.length) return undefined;

    return data.find((item) => item.id === id);
  }, [id, data]);

  const handleCreate = useCallback(async (qst) => {
    try {
      seIstUpdating(true);
      await ConstructorApi.createDocumentSection(qst);
      await queryClient.refetchQueries({ queryKey: ['getDocumentSections'] });
      showSuccessToast('created');
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      seIstUpdating(false);
    }
  }, []);

  const handleUpdate = useCallback(async (qst) => {
    try {
      seIstUpdating(true);
      await ConstructorApi.updateDocumentSection(qst);
      await queryClient.refetchQueries({ queryKey: ['getDocumentSections'] });
      showSuccessToast('Saved');
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      seIstUpdating(false);
    }
  }, []);

  const handleDelete = useCallback(async (section) => {
    try {
      setIsDeleting(true);
      await ConstructorApi.deleteDocumentSection(section);
      await queryClient.refetchQueries({ queryKey: ['getDocumentSections'] });
      showSuccessToast('Deleted');
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsDeleting(false);
    }
  }, []);

  const handleChangeRole = useCallback(async (role, checked) => {
    try {
      setIsChangingRole(true);

      if (checked) {
        await ConstructorApi.addRoleDocumentSection(id, role);
      } else {
        await ConstructorApi.deleteRoleDocumentSection(id, role);
      }
      await refetch();

      // if (checked) {
      //   showSuccessToast('Role Added');
      // } else {
      //   showSuccessToast('Role Removed');
      // }
    } catch (e) {
      showErrorToast(e, true);
    } finally {
      setIsChangingRole(false);
    }
  }, []);

  return {
    data: questionnaire,
    handleCreate,
    handleUpdate,
    handleDelete,
    handleChangeRole,
    isChangingRole,
    isDeleting,
    isLoading,
    isUpdating,
    isError,
    error
  };
};
